module.exports = __webpack_public_path__ + "a1d60ec40fea51d24675c5532ae52e7d.pdf";